import { Box, Text } from "@chakra-ui/react";
import React from "react";
import Faqs from "../../common/Faq/Faq";

const CoBrandedFaq = ({ faqData }: any) => {
  return (
    <Box maxW="1280px" mx="auto">
      <Text
        color="ms-red.900"
        fontFamily="poppins"
        textStyle={{ base: "h4", md: "h2" }}
        px={{ base: 8, md: 0 }}
        pb={{ base: 8, md: 6 }}
        textAlign="center"
      >
        {faqData?.title}
      </Text>
      <Faqs
        showHeader={false}
        faqs={faqData?.faqs}
        uniqueTypes={["co-branded"]}
      />
    </Box>
  );
};

export default CoBrandedFaq;
